<ng-container>
  @if (list?.length) {
    @for (listItem of list; track $index) {
      @if (listItem.valueOnNewLine) {
        <div
          class="data-table-row"
          [ngClass]="{
            'data-table-row__whitespace-top': listItem.whitespaceTop,
            'data-table-row__whitespace-bottom': listItem.whitespaceBottom,
            'data-table-row__whitespace-left': listItem.whitespaceLeft,
          }"
        >
          <span class="data-table-row__label-bold">{{ listItem.label }}</span>
        </div>
        @if (listItem.value !== undefined && listItem.value !== null) {
          <div class="data-table-row">
            {{ listItem.value }}
          </div>
        }
      } @else {
        <div
          class="data-table-row"
          [ngClass]="{
            'data-table-row__whitespace-top': listItem.whitespaceTop,
            'data-table-row__whitespace-bottom': listItem.whitespaceBottom,
            'data-table-row__whitespace-left': listItem.whitespaceLeft,
          }"
        >
          <span class="data-table-row__label data-table-row__label-bold">{{ listItem.label }}</span>

          @if (listItem.value !== undefined && listItem.value !== null) {
            <span class="data-table-row__value">{{ listItem.value }}</span>
          }
        </div>
      }
    }
  }
</ng-container>
